@if (show) {
<div
  class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 transition"
>
  <div class="bg-white rounded-xl shadow-lg p-8 w-full max-w-md">
    <h2 class="text-2xl font-bold text-gray-800 mb-4">Confirm Delete</h2>
    <p class="text-gray-700 mb-8">
      Are you sure you want to delete this item? This action cannot be undone.
    </p>
    <div class="flex justify-end gap-4">
      <button
        class="px-4 py-2 rounded bg-gray-200 hover:bg-gray-300 text-gray-700 font-semibold transition"
        (click)="cancel()"
      >
        Cancel
      </button>
      <button
        class="px-4 py-2 rounded bg-red-500 hover:bg-red-600 text-white font-semibold transition"
        (click)="confirm()"
      >
        Delete
      </button>
    </div>
  </div>
</div>
}
